<template>
  <div class="app-container product-center-page">
    <el-form
      ref="queryForm"
      :model="queryParams"
      class="multipleSelectScroll product-query"
      v-show="showSearch"
      label-width="86px"
    >
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商品搜索" prop="keyword">
            <el-input
              v-model="queryParams.keyword"
              placeholder="编码/名称/型号"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商品品类" prop="categoryName">
            <el-select
              v-model="queryParams.categoryName"
              placeholder="请选择商品品类"
              clearable
              filterable
              allow-create
              style="width:100%"
            >
              <el-option v-for="item in categoryOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商品状态" prop="status">
            <el-select v-model="queryParams.status" placeholder="请选择商品状态" clearable style="width:100%">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['crm:productCenter:save']" type="primary" icon="el-icon-plus" @click="handleAdd">
          新增商品
        </el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button icon="el-icon-download" :disabled="!dataList.length" @click="handleExport">
          导出当前清单
        </el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-row class="total-count">
      <span>商品总数：{{ summary.total }}</span>
      <span>启用：{{ summary.enabled }}</span>
      <span>待完善：{{ summary.trial }}</span>
      <span>非标：{{ summary.nonStandard }}</span>
      <span>历史合同命中：{{ summary.contractCount }}</span>
      <span>平均目标毛利率：{{ summary.avgTargetMargin }}%</span>
    </el-row>

    <el-table v-loading="loading" :data="dataList" @row-dblclick="handleView" height="calc(100vh - 330px)">
      <el-table-column label="商品编码" min-width="180" fixed="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="handleView(scope.row)">
            {{ scope.row.productCode }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="商品名称" min-width="190" fixed="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="product-name">
            <span>{{ scope.row.productName }}</span>
            <em v-if="scope.row.productModel">{{ scope.row.productModel }}</em>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="一级品类" prop="categoryName" min-width="110" align="center" />
      <el-table-column label="二级品类" prop="subCategoryName" min-width="110" align="center" show-overflow-tooltip />
      <el-table-column label="版本" prop="versionNo" width="80" align="center" />
      <el-table-column label="单位" prop="saleUnit" width="70" align="center" />
      <el-table-column label="标准售价" width="120" align="right">
        <template slot-scope="scope">{{ money(scope.row.standardPrice) }}</template>
      </el-table-column>
      <el-table-column label="最低售价" width="120" align="right">
        <template slot-scope="scope">{{ money(scope.row.floorPrice) }}</template>
      </el-table-column>
      <el-table-column label="标准成本" width="120" align="right">
        <template slot-scope="scope">{{ money(scope.row.standardCost) }}</template>
      </el-table-column>
      <el-table-column label="毛利率" width="90" align="right">
        <template slot-scope="scope">
          <span :class="{ danger: grossRate(scope.row) < Number(scope.row.targetGrossMargin || 0) }">
            {{ grossRate(scope.row) }}%
          </span>
        </template>
      </el-table-column>
      <el-table-column label="目标毛利" width="90" align="right">
        <template slot-scope="scope">{{ numberText(scope.row.targetGrossMargin) }}%</template>
      </el-table-column>
      <el-table-column label="合同命中" prop="sourceContractCount" width="90" align="center" />
      <el-table-column label="属性" width="80" align="center">
        <template slot-scope="scope">
          <el-tag v-if="Number(scope.row.nonStandardFlag) === 1" type="warning" size="mini">非标</el-tag>
          <el-tag v-else size="mini">标准</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusTag(scope.row.status)" size="mini">{{ statusText(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" prop="updateTime" width="160" align="center" />
      <el-table-column label="操作" width="150" fixed="right" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text" @click="handleView(scope.row)">查看</el-button>
          <el-button v-hasPermi="['crm:productCenter:save']" type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button v-hasPermi="['crm:productCenter:remove']" type="text" class="danger" @click="handleRemove(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer
      :visible.sync="detailOpen"
      :title="detailTitle"
      size="55%"
      custom-class="product-detail-drawer"
      append-to-body
    >
      <div v-if="detail.product" class="drawer-body">
        <el-descriptions :column="3" border>
          <el-descriptions-item label="商品编码">{{ detail.product.productCode }}</el-descriptions-item>
          <el-descriptions-item label="商品名称">{{ detail.product.productName }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ statusText(detail.product.status) }}</el-descriptions-item>
          <el-descriptions-item label="一级品类">{{ detail.product.categoryName }}</el-descriptions-item>
          <el-descriptions-item label="二级品类">{{ detail.product.subCategoryName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="型号规格">{{ detail.product.productModel || '-' }}</el-descriptions-item>
          <el-descriptions-item label="标准售价">{{ money(detail.product.standardPrice) }}</el-descriptions-item>
          <el-descriptions-item label="最低售价">{{ money(detail.product.floorPrice) }}</el-descriptions-item>
          <el-descriptions-item label="标准成本">{{ money(detail.product.standardCost) }}</el-descriptions-item>
          <el-descriptions-item label="税率">{{ numberText(detail.product.taxRate) }}%</el-descriptions-item>
          <el-descriptions-item label="目标毛利">{{ numberText(detail.product.targetGrossMargin) }}%</el-descriptions-item>
          <el-descriptions-item label="合同命中">{{ detail.product.sourceContractCount || 0 }}</el-descriptions-item>
          <el-descriptions-item label="交付范围" :span="3">
            {{ detail.product.deliveryScope || '-' }}
          </el-descriptions-item>
        </el-descriptions>

        <el-tabs v-model="detailTab" class="detail-tabs">
          <el-tab-pane label="交付与成本构成" name="bom">
            <el-alert
              class="field-help"
              type="info"
              :closable="false"
              show-icon
              title="BOM是商品的交付与成本构成，不等同于采购清单；只有用途为采购需求且开启生成采购的明细，才会进入合同履约里的采购需求底稿。"
            />
            <el-table :data="detail.bomList" border>
              <el-table-column label="序号" type="index" width="55" align="center" />
              <el-table-column label="明细名称" prop="itemName" min-width="170" show-overflow-tooltip />
              <el-table-column label="类型" width="90" align="center">
                <template slot-scope="scope">{{ itemTypeText(scope.row.itemType) }}</template>
              </el-table-column>
              <el-table-column label="供应方式" prop="supplyMode" width="110" align="center" />
              <el-table-column label="用途去向" width="110" align="center">
                <template slot-scope="scope">{{ purposeTypeText(scope.row.purposeType) }}</template>
              </el-table-column>
              <el-table-column label="生成采购" width="90" align="center">
                <template slot-scope="scope">{{ procurementFlagText(scope.row.generateProcurementFlag) }}</template>
              </el-table-column>
              <el-table-column label="用量" width="90" align="right">
                <template slot-scope="scope">{{ numberText(scope.row.quantity) }}</template>
              </el-table-column>
              <el-table-column label="单位" prop="unit" width="70" align="center" />
              <el-table-column label="单位成本" width="120" align="right">
                <template slot-scope="scope">{{ money(scope.row.standardUnitCost) }}</template>
              </el-table-column>
              <el-table-column label="损耗率" width="90" align="right">
                <template slot-scope="scope">{{ numberText(scope.row.lossRate) }}%</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="交付模板" name="delivery">
            <el-table :data="detail.deliveryTemplateList" border>
              <el-table-column label="序号" type="index" width="55" align="center" />
              <el-table-column label="任务名称" prop="taskName" min-width="180" show-overflow-tooltip />
              <el-table-column label="阶段" prop="taskStage" width="120" align="center" />
              <el-table-column label="责任角色" prop="ownerRole" width="120" align="center" />
              <el-table-column label="标准周期" width="100" align="center">
                <template slot-scope="scope">{{ scope.row.standardDays || 0 }}天</template>
              </el-table-column>
              <el-table-column label="必做" width="80" align="center">
                <template slot-scope="scope">{{ Number(scope.row.requiredFlag) === 1 ? '是' : '否' }}</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>

    <el-dialog :title="formTitle" :visible.sync="formOpen" width="1120px" append-to-body :close-on-click-modal="false">
      <el-form ref="productForm" :model="form" :rules="rules" label-width="96px" class="product-form">
        <el-divider content-position="left">商品主档</el-divider>
        <el-row :gutter="12">
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="商品编码" prop="productCode">
              <el-input v-model="form.productCode" placeholder="请输入商品编码" maxlength="80" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="商品名称" prop="productName">
              <el-input v-model="form.productName" placeholder="请输入商品名称" maxlength="120" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="型号规格" prop="productModel">
              <el-input v-model="form.productModel" placeholder="请输入型号规格" maxlength="100" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="一级品类" prop="categoryName">
              <el-select
                v-model="form.categoryName"
                placeholder="请选择或输入一级品类"
                filterable
                allow-create
                clearable
                style="width:100%"
              >
                <el-option v-for="item in categoryOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="二级品类" prop="subCategoryName">
              <el-input v-model="form.subCategoryName" placeholder="请输入二级品类" maxlength="50" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="版本" prop="versionNo">
              <el-input v-model="form.versionNo" placeholder="V1" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="销售单位" prop="saleUnit">
              <el-input v-model="form.saleUnit" placeholder="片/套/项/月" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="采购单位" prop="purchaseUnit">
              <el-input v-model="form.purchaseUnit" placeholder="请输入采购单位" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="交付单位" prop="deliveryUnit">
              <el-input v-model="form.deliveryUnit" placeholder="请输入交付单位" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="标准售价" prop="standardPrice">
              <el-input-number v-model="form.standardPrice" :min="0" :precision="2" controls-position="right" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="最低售价" prop="floorPrice">
              <el-input-number v-model="form.floorPrice" :min="0" :precision="2" controls-position="right" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="标准成本" prop="standardCost">
              <el-input-number v-model="form.standardCost" :min="0" :precision="2" controls-position="right" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="税率" prop="taxRate">
              <el-input-number v-model="form.taxRate" :min="0" :max="100" :precision="2" controls-position="right" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="目标毛利" prop="targetGrossMargin">
              <el-input-number
                v-model="form.targetGrossMargin"
                :min="0"
                :max="100"
                :precision="2"
                controls-position="right"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="商品状态" prop="status">
              <el-select v-model="form.status" placeholder="请选择商品状态" style="width:100%">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12" :lg="8">
            <el-form-item label="商品属性" prop="nonStandardFlag">
              <el-radio-group v-model="form.nonStandardFlag">
                <el-radio :label="0">标准商品</el-radio>
                <el-radio :label="1">非标商品</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="交付范围" prop="deliveryScope">
              <el-input
                v-model="form.deliveryScope"
                type="textarea"
                :rows="2"
                placeholder="请输入该商品默认交付范围"
                maxlength="500"
                show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-section-title">
          <span>交付与成本构成</span>
          <el-button type="text" icon="el-icon-plus" @click="addBom">新增明细</el-button>
        </div>
        <el-alert
          title="维护说明：这里配置的是商品交付和成本构成。采购项会生成采购需求；生产/备货项后续用于生产或备货；交付服务项后续用于交付任务；费用预算项后续进入项目成本预算。"
          type="info"
          :closable="false"
          show-icon
          class="section-alert"
        />
        <el-table :data="form.bomList" border class="edit-table">
          <el-table-column label="明细名称" min-width="180">
            <template slot="header">
              <span>明细名称</span>
              <el-tooltip content="填写该商品下具体的物料、服务、费用或资产名称，会作为后续采购/交付/成本明细名称。" placement="top">
                <i class="el-icon-question field-help-icon"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.itemName" placeholder="物料/服务/费用名称" />
            </template>
          </el-table-column>
          <el-table-column label="类型" width="110">
            <template slot="header">
              <span>类型</span>
              <el-tooltip content="区分明细的业务属性：物料、服务、费用或资产，影响后续分类统计。" placement="top">
                <i class="el-icon-question field-help-icon"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.itemType" placeholder="类型">
                <el-option v-for="item in itemTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="供应方式" width="130">
            <template slot="header">
              <span>供应方式</span>
              <el-tooltip content="说明这项由谁提供，例如外采、自产、内部服务、第三方服务；给采购和交付人员判断责任边界。" placement="top">
                <i class="el-icon-question field-help-icon"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.supplyMode" placeholder="采购/自产/服务" />
            </template>
          </el-table-column>
          <el-table-column label="用途去向" width="140">
            <template slot="header">
              <span>用途去向</span>
              <el-tooltip content="决定这条明细后续进入哪个业务环节。采购需求会进入采购底稿，生产/备货和交付服务后续用于对应任务，费用预算用于成本计划。" placement="top">
                <i class="el-icon-question field-help-icon"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.purposeType" placeholder="用途" @change="handleBomPurposeChange(scope.row)">
                <el-option v-for="item in purposeTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="生成采购" width="105" align="center">
            <template slot="header">
              <span>生成采购</span>
              <el-tooltip content="开启后，合同履约项目自动生成时会把这条明细带入采购需求；非采购类明细应关闭。" placement="top">
                <i class="el-icon-question field-help-icon"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-switch v-model="scope.row.generateProcurementFlag" :active-value="1" :inactive-value="0" />
            </template>
          </el-table-column>
          <el-table-column label="用量" width="120">
            <template slot="header">
              <span>用量</span>
              <el-tooltip content="每1个销售单位商品需要消耗多少本明细。生成采购时会用合同用量乘以这里的用量。" placement="top">
                <i class="el-icon-question field-help-icon"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.quantity" :min="0" :precision="4" controls-position="right" style="width:100%" />
            </template>
          </el-table-column>
          <el-table-column label="单位" width="90">
            <template slot="header">
              <span>单位</span>
              <el-tooltip content="该明细在采购、生产或服务交付中的计量单位，例如片、套、项、米。" placement="top">
                <i class="el-icon-question field-help-icon"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.unit" placeholder="单位" />
            </template>
          </el-table-column>
          <el-table-column label="单位成本" width="130">
            <template slot="header">
              <span>单位成本</span>
              <el-tooltip content="用于测算预计成本。采购类会进入采购需求预计金额，服务/费用类后续用于项目成本预算。" placement="top">
                <i class="el-icon-question field-help-icon"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.standardUnitCost"
                :min="0"
                :precision="2"
                controls-position="right"
                style="width:100%"
              />
            </template>
          </el-table-column>
          <el-table-column label="损耗率" width="110">
            <template slot="header">
              <span>损耗率</span>
              <el-tooltip content="采购类明细生成数量时会按损耗率放大，公式：合同用量 × BOM用量 × (1 + 损耗率/100)。" placement="top">
                <i class="el-icon-question field-help-icon"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.lossRate" :min="0" :max="100" :precision="4" controls-position="right" style="width:100%" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70" align="center">
            <template slot-scope="scope">
              <el-button type="text" class="danger" @click="removeBom(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="form-section-title">
          <span>交付模板</span>
          <el-button type="text" icon="el-icon-plus" @click="addDeliveryTask">新增任务</el-button>
        </div>
        <el-table :data="form.deliveryTemplateList" border class="edit-table">
          <el-table-column label="任务名称" min-width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.taskName" placeholder="请输入任务名称" />
            </template>
          </el-table-column>
          <el-table-column label="阶段" width="130">
            <template slot-scope="scope">
              <el-input v-model="scope.row.taskStage" placeholder="备货/发货/验收" />
            </template>
          </el-table-column>
          <el-table-column label="责任角色" width="130">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ownerRole" placeholder="销售/采购/交付" />
            </template>
          </el-table-column>
          <el-table-column label="标准周期" width="120">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.standardDays" :min="0" :precision="0" controls-position="right" style="width:100%" />
            </template>
          </el-table-column>
          <el-table-column label="必做" width="90" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.requiredFlag" :active-value="1" :inactive-value="0" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70" align="center">
            <template slot-scope="scope">
              <el-button type="text" class="danger" @click="removeDeliveryTask(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="formOpen = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProductItemDetail,
  listProductItems,
  removeProductItem,
  saveProductItem
} from '@/api/crm/productCenter'

const emptyProductForm = () => ({
  id: null,
  productCode: '',
  productName: '',
  categoryName: '',
  subCategoryName: '',
  productModel: '',
  versionNo: 'V1',
  saleUnit: '',
  purchaseUnit: '',
  deliveryUnit: '',
  standardPrice: 0,
  floorPrice: 0,
  standardCost: 0,
  taxRate: 13,
  targetGrossMargin: 0,
  sourceContractCount: 0,
  deliveryScope: '',
  status: 1,
  nonStandardFlag: 0,
  bomList: [],
  deliveryTemplateList: []
})

export default {
  name: 'ProductCenter',
  data() {
    return {
      loading: false,
      submitLoading: false,
      showSearch: true,
      detailOpen: false,
      formOpen: false,
      detailTab: 'bom',
      dataList: [],
      detail: {
        product: null,
        bomList: [],
        deliveryTemplateList: []
      },
      queryParams: {
        keyword: '',
        categoryName: '',
        status: null
      },
      form: emptyProductForm(),
      statusOptions: [
        { value: 1, label: '启用' },
        { value: 2, label: '待完善' },
        { value: 3, label: '停用' }
      ],
      itemTypeOptions: [
        { value: 1, label: '物料' },
        { value: 2, label: '服务' },
        { value: 3, label: '费用' },
        { value: 4, label: '资产' }
      ],
      purposeTypeOptions: [
        { value: 1, label: '采购需求' },
        { value: 2, label: '生产/备货' },
        { value: 3, label: '交付服务' },
        { value: 4, label: '费用预算' },
        { value: 5, label: '不生成下游' }
      ],
      rules: {
        productCode: [{ required: true, message: '商品编码不能为空', trigger: 'blur' }],
        productName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
        categoryName: [{ required: true, message: '一级品类不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    categoryOptions() {
      return [...new Set(this.dataList.map(item => item.categoryName).filter(Boolean))]
    },
    detailTitle() {
      if (!this.detail.product) {
        return '商品详情'
      }
      return `${this.detail.product.productName} - 商品详情`
    },
    formTitle() {
      return this.form.id ? '编辑商品' : '新增商品'
    },
    summary() {
      const total = this.dataList.length
      const enabled = this.dataList.filter(item => Number(item.status) === 1).length
      const trial = this.dataList.filter(item => Number(item.status) === 2).length
      const nonStandard = this.dataList.filter(item => Number(item.nonStandardFlag) === 1).length
      const contractCount = this.dataList.reduce((sum, item) => sum + Number(item.sourceContractCount || 0), 0)
      const marginTotal = this.dataList.reduce((sum, item) => sum + Number(item.targetGrossMargin || 0), 0)
      const avgTargetMargin = total ? (marginTotal / total).toFixed(1) : '0.0'
      return { total, enabled, trial, nonStandard, contractCount, avgTargetMargin }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      listProductItems(this.cleanParams(this.queryParams))
        .then(response => {
          this.dataList = (response && response.data) || []
        })
        .catch(() => {
          this.dataList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleQuery() {
      this.getList()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.queryParams = {
        keyword: '',
        categoryName: '',
        status: null
      }
      this.getList()
    },
    handleAdd() {
      this.form = emptyProductForm()
      this.formOpen = true
      this.$nextTick(() => {
        this.clearFormValidate()
      })
    },
    handleEdit(row) {
      this.loadDetail(row.id).then(detail => {
        this.form = this.toForm(detail)
        this.formOpen = true
        this.$nextTick(() => {
          this.clearFormValidate()
        })
      }).catch(() => {})
    },
    handleView(row) {
      this.loadDetail(row.id).then(detail => {
        this.detail = detail
        this.detailTab = 'bom'
        this.detailOpen = true
      }).catch(() => {})
    },
    handleRemove(row) {
      this.$confirm(`确认删除商品「${row.productName}」吗？`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return removeProductItem(row.id)
      }).then(() => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
    loadDetail(id) {
      return getProductItemDetail(id).then(response => {
        const data = (response && response.data) || {}
        return {
          product: data.product || {},
          bomList: data.bomList || [],
          deliveryTemplateList: data.deliveryTemplateList || []
        }
      })
    },
    submitForm() {
      this.$refs.productForm.validate(valid => {
        if (!valid) {
          return
        }
        const message = this.validateLines()
        if (message) {
          this.$message.warning(message)
          return
        }
        this.submitLoading = true
        saveProductItem(this.buildSubmitData())
          .then(() => {
            this.$message.success('保存成功')
            this.formOpen = false
            this.getList()
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
    validateLines() {
      if (Number(this.form.floorPrice || 0) > Number(this.form.standardPrice || 0)) {
        return '最低售价不能高于标准售价'
      }
      if (Number(this.form.standardCost || 0) > Number(this.form.standardPrice || 0)) {
        return '标准成本高于标准售价，请确认价格后再保存'
      }
      const invalidBom = this.form.bomList.some(item => !item.itemName)
      if (invalidBom) {
        return '交付与成本构成明细名称不能为空'
      }
      const invalidBomPurpose = this.form.bomList.some(item => !item.purposeType)
      if (invalidBomPurpose) {
        return 'BOM/服务包明细用途去向不能为空'
      }
      const invalidTask = this.form.deliveryTemplateList.some(item => !item.taskName)
      if (invalidTask) {
        return '交付模板任务名称不能为空'
      }
      return ''
    },
    buildSubmitData() {
      const data = JSON.parse(JSON.stringify(this.form))
      delete data.sourceContractCount
      data.bomList = data.bomList.map((item, index) => ({
        ...item,
        sortNo: index + 1,
        purposeType: Number(item.purposeType || 1),
        generateProcurementFlag: Number(item.generateProcurementFlag) === 1 ? 1 : 0,
        quantity: Number(item.quantity || 0),
        standardUnitCost: Number(item.standardUnitCost || 0),
        lossRate: Number(item.lossRate || 0)
      }))
      data.deliveryTemplateList = data.deliveryTemplateList.map((item, index) => ({
        ...item,
        sortNo: index + 1,
        standardDays: Number(item.standardDays || 0),
        requiredFlag: Number(item.requiredFlag) === 1 ? 1 : 0
      }))
      return data
    },
    toForm(detail) {
      const product = detail.product || {}
      return {
        ...emptyProductForm(),
        ...product,
        standardPrice: Number(product.standardPrice || 0),
        floorPrice: Number(product.floorPrice || 0),
        standardCost: Number(product.standardCost || 0),
        taxRate: Number(product.taxRate || 0),
        targetGrossMargin: Number(product.targetGrossMargin || 0),
        sourceContractCount: Number(product.sourceContractCount || 0),
        status: Number(product.status || 1),
        nonStandardFlag: Number(product.nonStandardFlag || 0),
        bomList: (detail.bomList || []).map(item => ({
          ...item,
          itemType: Number(item.itemType || 1),
          purposeType: Number(item.purposeType || 1),
          generateProcurementFlag: Number(item.generateProcurementFlag) === 0 ? 0 : 1,
          quantity: Number(item.quantity || 0),
          standardUnitCost: Number(item.standardUnitCost || 0),
          lossRate: Number(item.lossRate || 0)
        })),
        deliveryTemplateList: (detail.deliveryTemplateList || []).map(item => ({
          ...item,
          standardDays: Number(item.standardDays || 0),
          requiredFlag: Number(item.requiredFlag) === 0 ? 0 : 1
        }))
      }
    },
    addBom() {
      this.form.bomList.push({
        itemName: '',
        itemType: 1,
        supplyMode: '',
        purposeType: 1,
        generateProcurementFlag: 1,
        quantity: 1,
        unit: this.form.saleUnit || '',
        standardUnitCost: 0,
        lossRate: 0
      })
    },
    removeBom(index) {
      this.form.bomList.splice(index, 1)
    },
    handleBomPurposeChange(row) {
      row.generateProcurementFlag = Number(row.purposeType) === 1 ? 1 : 0
    },
    addDeliveryTask() {
      this.form.deliveryTemplateList.push({
        taskName: '',
        taskStage: '',
        ownerRole: '',
        standardDays: 0,
        requiredFlag: 1
      })
    },
    removeDeliveryTask(index) {
      this.form.deliveryTemplateList.splice(index, 1)
    },
    clearFormValidate() {
      if (this.$refs.productForm) {
        this.$refs.productForm.clearValidate()
      }
    },
    handleExport() {
      const header = [
        '商品编码',
        '商品名称',
        '一级品类',
        '二级品类',
        '型号规格',
        '标准售价',
        '最低售价',
        '标准成本',
        '目标毛利率',
        '历史合同命中数',
        '状态'
      ]
      const rows = this.dataList.map(item => [
        item.productCode,
        item.productName,
        item.categoryName,
        item.subCategoryName,
        item.productModel,
        item.standardPrice,
        item.floorPrice,
        item.standardCost,
        item.targetGrossMargin,
        item.sourceContractCount,
        this.statusText(item.status)
      ])
      const csv = [header, ...rows].map(row => row.map(this.csvCell).join(',')).join('\n')
      const blob = new Blob([`\ufeff${csv}`], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `商品中心_${this.formatDate(new Date())}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
    cleanParams(params) {
      const data = { ...params }
      Object.keys(data).forEach(key => {
        if (data[key] === '' || data[key] === null || data[key] === undefined) {
          delete data[key]
        }
      })
      return data
    },
    statusText(status) {
      const item = this.statusOptions.find(option => Number(option.value) === Number(status))
      return item ? item.label : '-'
    },
    statusTag(status) {
      if (Number(status) === 2) {
        return 'warning'
      }
      if (Number(status) === 3) {
        return 'info'
      }
      return 'success'
    },
    itemTypeText(type) {
      const item = this.itemTypeOptions.find(option => Number(option.value) === Number(type))
      return item ? item.label : '-'
    },
    purposeTypeText(type) {
      const item = this.purposeTypeOptions.find(option => Number(option.value) === Number(type))
      return item ? item.label : '-'
    },
    procurementFlagText(value) {
      return Number(value) === 1 ? '是' : '否'
    },
    grossRate(row) {
      const price = Number(row.standardPrice || 0)
      const cost = Number(row.standardCost || 0)
      if (!price) {
        return '0.0'
      }
      return (((price - cost) / price) * 100).toFixed(1)
    },
    money(value) {
      const number = Number(value || 0)
      return number.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    numberText(value) {
      const number = Number(value || 0)
      return Number.isInteger(number) ? String(number) : String(number)
    },
    csvCell(value) {
      const text = value === null || value === undefined ? '' : String(value)
      return `"${text.replace(/"/g, '""')}"`
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}${month}${day}`
    }
  }
}
</script>

<style lang="scss" scoped>
.product-center-page {
  min-height: calc(100vh - 84px);
}

.product-query {
  margin-bottom: 8px;
}

.total-count {
  margin: 6px 0 12px;
  color: #606266;
  font-size: 14px;

  span {
    display: inline-block;
    margin-right: 28px;
    line-height: 28px;
    white-space: nowrap;
  }
}

.product-name {
  span,
  em {
    display: block;
  }

  em {
    margin-top: 3px;
    color: #909399;
    font-size: 12px;
    font-style: normal;
  }
}

.danger {
  color: #f56c6c !important;
}

.drawer-body {
  padding: 0 20px 24px;
}

.detail-tabs {
  margin-top: 16px;
}

.field-help {
  margin-bottom: 10px;
}

.field-help-icon {
  margin-left: 4px;
  color: #909399;
  cursor: help;
}

.product-form {
  max-height: 68vh;
  overflow-y: auto;
  padding-right: 8px;
}

.form-section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 18px 0 10px;
  font-weight: 600;
  color: #303133;
}

.section-alert {
  margin-bottom: 10px;
}

.edit-table {
  margin-bottom: 8px;
}

::v-deep .product-detail-drawer .el-drawer__header {
  margin-bottom: 12px;
}

@media (max-width: 900px) {
  .total-count span {
    display: block;
  }
}
</style>
